module.exports = __webpack_public_path__ + "img/8829b77.svg";